import { useMemo, type RefObject } from 'react';

import { useResizeObserver } from '../../../core/hooks/useResizeObserver.js';
import { throttleRaf } from '../utils/throttleRaf.js';

export const useThrottledCallbackOnResize = (
  subject: RefObject<HTMLElement>,
  callback: () => void,
  disabled = false,
): void => {
  const throttledCallback = useMemo(
    disabled
      ? () => () => {
          /* no op */
        }
      : () => throttleRaf(callback),
    [disabled],
  );

  useResizeObserver<HTMLElement>({
    ref: subject,
    onResize: throttledCallback,
  });
};
